<section class="section old-legacy-code-tile">
    <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
    <h1 class="title title__full-width">{{ getH1String() }}</h1>

    <!--Tab switcher -->
    <div class="tab-switcher">
      <ul class="tab-switcher__list ">
        <li tabindex="1" class="tab-switcher__item ">
          <a href="/press-centr" class="tab-switcher__link ">Последние публикации</a>
        </li>
        <li tabindex="2" class="tab-switcher__item  js-focus ">
          <a href="/novosti/news" class="tab-switcher__link  tab-switcher__link--active ">Новости</a>
        </li>
        <li tabindex="3" class="tab-switcher__item ">
          <a href="/press-centr/video" class="tab-switcher__link ">Фото и видео</a>
        </li>
      </ul>
    </div>

    <div class="news-section">
      <form>
        <div class="press-center__select">
          <!-- Первое выпадающее меню: Категории -->
          <div class="press-center__categories">
            <div class="select" (click)="toggleOptions('categories')">
              <select
                [formControl]="$any(form.get('category'))"
                name="categories"
                id="select-categories"
                class="select select--hidden"
              >
                <option
                  *ngFor="let category of newsCategories"
                  [value]="category.categoryCode"
                >
                  {{ category.categoryName }}
                </option>
              </select>
              <div class="select--styled"
                   [ngClass]="{ 'active': showCategoriesOptions }"
              >{{ selectedCategoryName || 'Новости' }}
              </div>
              <ul
                class="select__options select__options--links"
                [ngStyle]="{'display': showCategoriesOptions ? 'block' : 'none'}"
              >
                <li
                  *ngFor="let category of newsCategories"
                  class="select__list-element"
                  (click)="onCategorySelect(category, $event)"
                >
                  {{ category.categoryName }}
                </li>
              </ul>
            </div>
          </div>

          <!-- Второе выпадающее меню: Комплексы -->
          <ng-container *ngIf="showComplexSelect($any(form.get('category')))">
            <div class="press-center__complexes">
              <div class="select" (click)="toggleOptions('complexes')">
                <select
                  [formControl]="$any(form.get('complexTitle'))"
                  name="complexes" id="select-complexes" class="select select--hidden">
                  <option *ngFor="let complexTitle of complexTitles" [value]="complexTitle">
                    {{ complexTitle }}
                  </option>
                </select>
                <div class="select--styled"
                     [ngClass]="{ 'active': showComplexesOptions }"
                >
                  {{ selectedComplexName || 'Выберите комплекс' }}
                </div>
                <ul
                  class="select__options select__options--links"
                  [ngStyle]="{'display': showComplexesOptions ? 'block' : 'none'}"
                >
                  <li
                    *ngFor="let complexTitle of complexTitles"
                    (click)="onComplexSelect(complexTitle, $event)"
                    class="select__list-element"
                  >
                    {{ complexTitle }}
                  </li>
                </ul>
              </div>
            </div>
          </ng-container>
        </div>
      </form>
    </div>
    <div>
      <app-loader *ngIf="loadingStatus !== 'ready'"></app-loader>
    </div>
    <ng-container *ngIf="loadingStatus === 'ready'">
      <div class="news-container">
        <ng-container *ngFor="let newsItem of newsItems">
          <div class="news-link" (click)="goToNews(newsItem)">
            <div class="news-item">
              <div class="news-image">
                <picture>
                  <source *ngIf="newsItem.preview.pathWebp" srcset="{{ newsItem.preview.pathWebp }}" type="image/webp">
                  <img [src]="newsItem.preview.path" alt="{{ newsItem.title }}" fill="">
                </picture>
              </div>
              <div class="news-content">
                <a class="news-title" [attr.aria-label]="newsItem.title"
                   [href]="newsItem | newsUrl">{{ newsItem.title }}</a>
                <a class="news-complex" [attr.aria-label]="newsItem.complexTitle"
                   [href]="prepareComplexLink(newsItem.complexSlug)">{{ newsItem.complexTitle }}</a>
                <span class="news-category">{{ newsItem.directoryValue }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <app-pagination [countItems]="newsCount"></app-pagination>
</section>
